var React = require('react');

function LineMobile1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.917969 1.7688H84.3352C100.826 1.7688 114.195 15.1373 114.195 31.6282V52.7188C114.195 69.2097 127.563 82.5782 144.054 82.5782H147","stroke":"white","strokeWidth":"2.15"}));
}

LineMobile1.defaultProps = {"width":"147","height":"84","viewBox":"0 0 147 84","fill":"none"};

module.exports = LineMobile1;

LineMobile1.default = LineMobile1;
